import { useMutation, useQuery } from 'react-query'
import { config } from 'config'
import { callAxios, CustomAxiosError } from 'utils/api'
import { GetQueriesRequest, GetQueryResponse, UpdateLastUsedTimeRequest } from 'types/saveLoadQuery'

const { SECURE_BASE_URL } = config!

const getQueries = async (props: GetQueriesRequest): Promise<GetQueryResponse> => {
  const { vendorNumber, userId, reportName } = props

  const { response: queryResponse } = await callAxios<{
    response: { data: GetQueryResponse }
  }>({
    url: `${SECURE_BASE_URL}/getallqueries?vendornumber=${vendorNumber}&userid=${userId}&reportname=${reportName}`,
    method: 'GET',
  })

  return queryResponse.data
}

export const useGetQueries = (props: GetQueriesRequest) => {
  const { vendorNumber, userId, reportName } = props

  const {
    status: getQueriesStatus,
    data: getQueriesData,
    error: getQueriesError,
    refetch: fetchQueriesData,
    remove: resetQueriesData,
  } = useQuery<GetQueryResponse, CustomAxiosError>(['loadSaveQueries/get', props], () => getQueries(props), {
    enabled: !!vendorNumber && !!userId && !!reportName,
  })

  return {
    getQueriesStatus,
    getQueriesData,
    getQueriesError,
    fetchQueriesData,
    resetQueriesData,
  }
}

const updateLastUsedTime = async (props: UpdateLastUsedTimeRequest): Promise<any> => {
  const { vendorNumber, userId, reportName, queryTitle } = props

  const { response: lastUsedTimeResponse } = await callAxios<{ response: any }>({
    url: `${SECURE_BASE_URL}/updatelastusedtime`,
    method: 'POST',
    data: {
      vendornumber: vendorNumber,
      userid: userId,
      querytitle: queryTitle,
      reportname: reportName,
    },
  })

  return lastUsedTimeResponse
}

export const useUpdateLastUsedTime = () => {
  const { mutate: mutateUpdateLastUsedTime, reset: resetUpdateLastUsedTime } = useMutation<
    any,
    CustomAxiosError,
    UpdateLastUsedTimeRequest
  >(updateLastUsedTime)

  return {
    mutateUpdateLastUsedTime,
    resetUpdateLastUsedTime,
  }
}
